const getHumanReadableModelName = (args) => {
  if ("json" in args.model) {
    return args.model.label || args.model.id;
  } else if ("type" in args.model && args.model.type === "SharedSlice") {
    return args.model.name;
  } else if ("type" in args.model && args.model.type === "Slice") {
    return args.model.fieldset || args.name;
  } else if ("type" in args.model) {
    if (args.model.config && "label" in args.model.config) {
      return args.model.config.label || args.name;
    } else if (args.model.config && "fieldset" in args.model) {
      return args.model.fieldset || args.name;
    }
  }
  return `\`${args.name}\``;
};
export {
  getHumanReadableModelName
};
//# sourceMappingURL=getHumanReadableModelName.js.map
